(function(){
    'use strict';

    angular.module('elogbooks.common.operatives', []);
})();
